/* DefaultForComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./DefaultForRenderer");
const _ = require("lodash");

class DefaultForComponent extends DefaultColumnComponent {
    constructor(entity, ctx) {
        super(entity);
        this._entity = entity;
        this._ctx = ctx;
        this._value = this._getDefaultIfEligible();

        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/
    _getDefaultIfEligible() {
        return this._ctx.orgId === this._entity.tenantId && this._ctx.userId === this._entity.ownerId
            ? _.get(this._entity, this._ctx.column, false)
            : false;
    }
    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        this.setDefaultFor(newVal || false);
    }

    getValue() {
        return this.getDefaultFor();
    }

    setDefaultFor(/*newVal*/) {
        this._value = this._getDefaultIfEligible();
        this.emit("DefaultFor", this._value);
        return this;
    }

    getDefaultFor() {
        return this._value || false;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = DefaultForComponent;
